import React from 'react';
import Slider from 'react-slick';

const SliderComponentWeb = ({ props, children }) => <Slider {...props}> {children} </Slider>;
export default SliderComponentWeb;
